import React, { createContext, useContext, useMemo, useState } from "react";
import en from "./locales/en.json";
import it from "./locales/it.json";

const LOCALES = { en, it };
const I18nContext = createContext(null);

export function I18nProvider({ defaultLocale = "it", children }) {
  const [locale, setLocale] = useState(defaultLocale);
  const dict = LOCALES[locale] || LOCALES.en;

  const value = useMemo(() => {
    const t = (key, vars) => {
      const parts = key.split(".");
      let val = parts.reduce((acc, p) => (acc && acc[p] ? acc[p] : null), dict);
      if (val == null) return key; // fallback: mostra la chiave se manca la traduzione
      if (vars) {
        Object.keys(vars).forEach((k) => {
          val = val.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k]));
        });
      }
      return val;
    };
    return { locale, setLocale, t };
  }, [locale, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useTranslation = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useTranslation must be used within I18nProvider");
  return ctx;
};
